import React from "react";
import { Button, Container } from "react-bootstrap";
import { MdErrorOutline } from "react-icons/md";

const DarkAdmin404 = () => {
  return (
    <div className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh", background: "#1a1d21" }}>
      
      <Container className="text-center text-white">

        <MdErrorOutline size={90} className="text-warning mb-3" />

        <h1 className="fw-bold" style={{ fontSize: "4rem" }}>404</h1>
        <h4 className="fw-semibold">Page Not Found</h4>

        <p className="text-secondary mt-2">
          The page you're looking for doesn't exist.
        </p>

        <Button variant="warning" href="/admin" className="px-4 py-2 mt-3">
          Back to Dashboard
        </Button>

      </Container>
    </div>
  );
};

export default DarkAdmin404;
